<script setup lang="ts">
/** A small section heading inside a menu („Zuletzt geöffnet“). Not focusable. */
</script>

<template>
  <div class="nx-context-menu-label" role="presentation"><slot /></div>
</template>

<style scoped>
.nx-context-menu-label {
  padding: var(--nxt-space-xs) var(--nxt-space-sm) var(--nxt-space-2xs);
  color: var(--nxt-fg-muted);
  font-size: var(--nxt-font-size-xs);
  font-weight: var(--nxt-font-weight-medium);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
</style>
